"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionCell = void 0;
const crate_1 = require("@tcc/crate");
const react_1 = __importDefault(require("react"));
const SelectionCell = ({ column, row: { getIsSelected, getToggleSelectedHandler, id } }) => {
    const testId = `fds-table-selection-cell-${column.id}-${id}`;
    return react_1.default.createElement(crate_1.Checkbox, { testId: testId, checked: getIsSelected(), onChange: getToggleSelectedHandler() });
};
exports.SelectionCell = SelectionCell;
